import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog";
import { Button, TableCell, Grid } from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { EnhancedTable } from "components/Global/Table/EnhancedTable";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";

const NewButton = styled(Button)`
  && {
    margin: 0 0 -4px 4px;
    padding: 8px 8px 0px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  & span {
    margin-left: 4px;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;

export const VerticalDivider = styled.div`
  height: 34px;
  border-right: 1px solid #cccccc;
`;

export class GuestGroupsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDeleteGuestGroupModalOpen: false
    };
  }

  buildNavLink = (route, label) => (
    <NavLink exact to={route}>
      <NewButton>{label}</NewButton>
    </NavLink>
  );

  guestGroupsTableColumns = [
    {
      id: "guestGroupName",
      label: "Name",
      isString: true,
      isBaseColumn: true,
      dataField: "name"
    },
    {
      id: "numberOfGuests",
      label: "No. of Guests",
      numeric: true,
      cellValueCalculator: guestGroup =>
        guestGroup.numberOfGuests ||
        (guestGroup.guestgroups && guestGroup.guestgroups.length) ||
        0
    },
    {
      id: "actions",
      actions: true,
      blankLabel: true,
      width: 320,
      cell: ({ data }) => (
        <TableCell>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="right"
            spacing={8}
          >
            <Grid item>
              <NewButton
                variant="contained"
                onClick={() =>
                  this.setState({
                    guestGroupToDelete: data,
                    isDeleteGuestGroupModalOpen: true
                  })
                }
              >
                Delete
              </NewButton>
            </Grid>
            <Grid item>
              <VerticalDivider />
            </Grid>
            <Grid item>
              {this.buildNavLink(
                `/admin/guestGroup/${data.id}`,
                "Manage Members"
              )}
            </Grid>
          </Grid>
        </TableCell>
      )
    }
  ];

  render() {
    return (
      <Fragment>
        <EnhancedTable
          columnDefinitions={this.guestGroupsTableColumns}
          rows={this.props.guestGroups}
          orderBy={this.guestGroupsTableColumns[0]}
          order={EnhancedTable.ASC_ORDER}
          shouldHideConfig
          shouldHideExport
          noSearchResultsFoundMessage="No Guest Groups have been found"
          noRowsMessage="No Guest Groups have been found"
          width="100%"
        />

        <SimpleConfirmDialog
          title="Confirm Delete"
          message={<span>You are about to delete this guest group.  This will not affect current access to deals.<br /><br />Are you sure you want to do this?</span>}
          noText="NO"
          yesText="YES, DELETE"
          modalOpen={this.state.isDeleteGuestGroupModalOpen}
          handleNo={() => this.setState({ isDeleteGuestGroupModalOpen: false })}
          handleYes={() => {
            this.props.deleteGuestGroup(this.state.guestGroupToDelete);
            this.setState({ isDeleteGuestGroupModalOpen: false });
          }}
        />
      </Fragment>
    );
  }
}

GuestGroupsTable.propTypes = {
  guestGroups: PropTypes.object.isRequired,
  deleteGuestGroup: PropTypes.func.isRequired
};

function mapStateToProps() {
  return {};
}

export default compose(
  connect(
    mapStateToProps,
    {}
  )
)(GuestGroupsTable);
